'use client';

import React from 'react';

const FloorplanLoader = () => {
  return (
    <>
      {/* Mobile View */}
      <div className="md:hidden min-h-screen bg-white">
        <div className="bg-black h-8 w-full" />
        <div className="mt-14 px-6 py-4">
          {/* Top line — more rounded */}
          <div
            className="bg-background-secondary h-7 w-32 rounded-[10px] mb-3 animate-pulse"
            style={{ animationDelay: '0ms' }}
          />
          {/* Bottom line — slightly flatter */}
          <div
            className="bg-background-secondary h-5 w-24 rounded-[8px] mb-3 animate-pulse"
            style={{ animationDelay: '100ms' }}
          />
        </div>
        <div>
          {/* Main content - full width on mobile */}
          <div
            className="bg-background-secondary w-full h-[700px] rounded-[40px] animate-pulse"
            style={{ animationDelay: '200ms' }}
          />
        </div>
      </div>

      {/* Desktop View */}
      <div className="hidden md:block min-h-screen bg-white py-8 ">
        <div className=" mt-6 min-h-screen ">
          {/* Header section */}
          <div className="mb-3 py-6 lg:px-0">
            <div
              className="bg-background-secondary h-7 w-40  rounded-[10px] mb-3 animate-pulse"
              style={{ animationDelay: '0ms' }}
            />
            <div
              className="bg-background-secondary h-3 w-32 rounded-lg animate-pulse"
              style={{ animationDelay: '100ms' }}
            />
          </div>

          {/* Main content grid */}
          <div className="grid grid-cols-1 w-full lg:grid-cols-4 gap-3">
            {/* Main floorplan area */}
            <div
              className="lg:col-span-4 bg-background-secondary rounded-xl w-full h-[400px] lg:h-[600px] animate-pulse"
              style={{ animationDelay: '200ms' }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FloorplanLoader;
